import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../components/ui/dialog.jsx";

export const CalendlyModal = ({ trigger }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Load Calendly script when modal opens
    if (open) {
      const script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      document.head.appendChild(script);

      return () => {
        // Clean up script when component unmounts
        const existingScript = document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]');
        if (existingScript) {
          document.head.removeChild(existingScript);
        }
      };
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger({ onClick: () => setOpen(true) })}
      </DialogTrigger>
      <DialogContent className="max-w-5xl p-0 overflow-hidden bg-black/90 backdrop-blur-2xl border border-white/10">
        <DialogHeader className="p-6 pb-3">
          <DialogTitle className="text-white">Book a Call</DialogTitle>
        </DialogHeader>
        <div className="px-4 pb-6">
          <div 
            className="calendly-inline-widget" 
            data-url="https://calendly.com/skyriseco/30min?hide_landing_page=1&hide_gdpr_banner=1" 
            style={{ width: "100%", minWidth: "320px", height: "70vh", minHeight: "50vh" }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
